module.exports = __webpack_public_path__ + "static/media/jul2.dc1e9c00.jpg";